import script from "./PromptSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromptSettings.vue?vue&type=script&setup=true&lang=ts"

import "./PromptSettings.scss?vue&type=style&index=0&id=019d2fe3&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019d2fe3"]])

export default __exports__